import Academy from "./Academy";
import MyFinance from "./MyFinance";
const pages = { Academy, MyFinance };

export default pages;
